import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Form, Row, Col, Input, Select, Button, Tooltip, Tabs, Checkbox, DatePicker, Divider, Dropdown, Menu, Spin, Space, Drawer, Table} from 'antd'
import { QuestionCircleFilled, CloseOutlined, IeOutlined, EyeOutlined, ExclamationCircleFilled, ExclamationCircleOutlined } from '@ant-design/icons'
import TemplateList from './TemplateList'
import FormImport from './FormImport'
import ShortLinkList from './ShortLinkList'
import PhoneList from './PhoneList'
import PersonalPhoneList from './PersonalPhoneList'
import EditVarModal from './EditVarModal'
import PersonalSearchResult from './PersonalSearchResult'
import ResourcePoolList from '../../marketingResourcePool/components/ResourcePoolList'
import {withTranslation} from 'react-i18next'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import alertMessage from '../../../utils/alertMessage'
import history from '../../../routes/history'
import moment from 'moment'
const storage = window.localStorage
const { TabPane } = Tabs;
const {TextArea} = Input
@inject('marketingSmsManagementStore', 'marketingSmsTemplateStore', 'marketingShortLinkStore', 'accountStore')
@observer
class FormModal extends Component {
  state = {
    smsType: this.props?.location?.state?.smsType || '1',
    signNum: 0,   //签名
    characterNum: 0,  //模板内容
    suffixNum: 0,  //后缀
    strNum: 0,  //字符数
    smsNum: 0,  //短信数
    regularlyTime: null,
    modalVisible: false,
    importModalVisible: false,
    shortLinkModalVisible: false,
    detailsModalVisible: false,
    content: '',
    textAreaStart: 0,
    sum: 0,
    signName: '',
    sourceType: '',
    isValid: '',
    groupVal: '',
    editVarVisible: false,
    phoneContent: '',
    personalPhoneVisible: false,
    record: null,
    isTable: this.props?.location?.state?.smsType==='2' ? true : false,
    isFile: false,
    isResourcePool: this.props?.location?.state?.smsType==='2' ? true : false,
    selectedTime: null,
    isDatePicker: 0,
    isFormPool: this.props?.location?.state?.smsType==='2' ? true : false,
    testSendModalVisible: false,
    testTableData: [], // 测试表格数据
    testTableColumns: [], // 测试表格列配置
  }

  formRef = React.createRef()
  testFormRef = React.createRef()

  componentDidMount() {
    const {marketingSmsManagementStore, location, type, t} = this.props
    const { generateID } = marketingSmsManagementStore
    if(type==='1') {
      const suffixNum = t(`marketingManagement.replyWithR`)?.length || 0
      this.setState({
        suffixNum: suffixNum,
        strNum: suffixNum,
        smsNum: 1
      })
      this.formRef.current.setFieldsValue({
        'suffixContent': t(`marketingManagement.replyWithR`),
      })
    }
    marketingSmsManagementStore.onStatisticsAction({
      "smsType": this.state.smsType,
      "taskGroupId": generateID,
      "taskType": type
    })
    marketingSmsManagementStore.onExpoAction()
    this.formRef.current.setFieldsValue({
      marketingGroupId: location?.state?.marketGroupId || undefined
    })
    if(location?.state?.marketGroupId) {
      this.onChangeGroup(location?.state?.marketGroupId)
    }

    if (location?.state) {
      history.replace({
        state: {} // 清空路由状态
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {type, t} = this.props
    this.formRef.current.setFieldsValue({
      'suffixContent': type==='1' ? t(`marketingManagement.replyWithR`) : undefined
    })
  }
  // 点击按钮 提交发送
  handleOk = () => {
    const {marketingSmsManagementStore, type} = this.props
    const {templateObj, generateID, handPhoneNum, filePhoneNum, resourcePhoneNum, templateParams} = marketingSmsManagementStore
    this.formRef.current.validateFields().then(fieldsValue => {
      if(fieldsValue?.content) {
        if((handPhoneNum+filePhoneNum+resourcePhoneNum)>0) {
          let params = {
            taskGroupId: generateID,
            taskType: type,  //任务类型 1营销短信2通知短信
            smsType: this.state.smsType, //短信类型 1普通短信2个性短信
            taskName: fieldsValue?.taskName,
            marketingGroupId: fieldsValue?.marketingGroupId,
            expoResume: fieldsValue?.expoResume,
            suffixContent: fieldsValue?.suffixContent,
            signId: fieldsValue?.signId,
            templateParams: this.state.smsType==='1' ? templateObj ? templateParams.map(a=>{return a?.value}) : [] : null,
            variable: this.state.smsType==='2' ? templateObj ? templateParams.map(a=>{return {...a, key: a?.key?.replace(/{%|%}/g, "")}}) : [] : null,
            content: fieldsValue?.content,
            isSchedule: this.state.regularlyTime ? 0 : 1, //是否定时发送 0是 1否
            scheduleTime: fieldsValue?.scheduleTime ? moment(fieldsValue?.scheduleTime).format('YYYY-MM-DD HH:mm:ss') : null,
            useTemplate: templateObj ? 0 : 1,   //是否使用模板 0是 1否
            templateId: templateObj ? templateObj.id : null
          }
          marketingSmsManagementStore.onAddAction(params).then(res=> {
            if (res?.data?.code === 0) {
              this.formHandleCancel('',true)
            }
          })
        } else {
          alertMessage.error('请输入手机号码!')
        }
      } else {
        alertMessage.error('请输入短信内容!')
      }
    }).catch(() => {})
  }

  handleOkConfirm = () => {
    const {t, marketingSmsManagementStore} = this.props
    const that = this
    const {handPhoneNum, filePhoneNum, resourcePhoneNum} = marketingSmsManagementStore
    this.formRef.current.validateFields().then(fieldsValue => {
      if (fieldsValue?.content) {
        if ((handPhoneNum + filePhoneNum + resourcePhoneNum) > 0) {
          Modal.confirm({
            title: '是否确定发送',
            icon: <ExclamationCircleOutlined/>,
            centered: true,
            content: <div>
              {t(`marketingManagement.total4`)}
              <span style={{color: '#ff5200'}}>
                      {this.state.signNum + this.state.phoneContent?.length + this.state.suffixNum}
                    </span>
              {t(`marketingManagement.total2`)}
              <span
                style={{color: 'red'}}>{(this.state.signNum + this.state.phoneContent?.length + this.state.suffixNum) > 70 ? Math.ceil((this.state.signNum + this.state.phoneContent?.length + this.state.suffixNum) / 67) : 1}</span>
              {t(`marketingManagement.total3`)}
            </div>,
            onOk() {
              that.handleOk()
              console.log('OK')
            },
            onCancel() {
              // console.log('Cancel')
            },
          })
        } else {
          alertMessage.error('请输入手机号码!')
        }
      } else {
        alertMessage.error('请输入短信内容!')
      }
    }).catch(() => {})
  }

  //切换 普通短信 和 个性短信
  onChange = (value) => {
    const {marketingSmsManagementStore, type, location, t} = this.props
    this.onChangeGroup('',false)
    this.setState({
      smsType: value,
      signName: '',
      regularlyTime: null,
      selectedTime: null,
      isFormPool: false,
    })
    this.formRef.current.setFieldsValue({
      'marketingGroupId': undefined,
      'signId': undefined,
      'expoResume': undefined,
      'suffixContent': type==='1' ? t(`marketingManagement.replyWithR`) : undefined,
      'scheduleTime': null,
    })
    marketingSmsManagementStore.onChangeSmsBalanceSum(0)
  }
  // 修改 营销分组
  onChangeGroup = (value, isFormPool) => {
    const { marketingSmsManagementStore, type, location } = this.props
    const { generateID, phoneList, excelList, signList } = marketingSmsManagementStore
    const sign = signList?.find(a=>a?.marketingGroupId ===value && a?.isDefault===0)?.id || undefined
    const defaultSignName = signList?.find(a=>a?.marketingGroupId ===value && a?.isDefault===0)?.sign || undefined
    this.formRef.current.setFieldsValue({
      'signId': sign,
      'content': undefined,
      'expoResume': undefined,
    })
    this.setState(prevState => {
      const strSum = parseInt(prevState.suffixNum)
      return {
        groupVal: value,
        signNum: defaultSignName ? `【${defaultSignName}】`.length : 0,
        characterNum: 0,
        strNum: strSum + (defaultSignName ? `【${defaultSignName}】`.length : 0),
        smsNum: strSum + (defaultSignName ? `【${defaultSignName}】`.length : 0) > 70 ? Math.ceil(strSum / 67) : 1,
        phoneContent: '',
        content: '',
        signName: defaultSignName ? `【${defaultSignName}】` : ''
      }
    })
    marketingSmsManagementStore.onChangeTemplateObj(null)
    marketingSmsManagementStore.onChangeTemplateParams([])
    marketingSmsManagementStore.onChangePhoneTable([])
    marketingSmsManagementStore.onChangeExcelList([])
    if(!isFormPool) {
      if(marketingSmsManagementStore.phoneList.length>0 || marketingSmsManagementStore.excelList.length>0) {
        /* 清空号码 */
        marketingSmsManagementStore.onClearPhoneAction({
          "taskGroupId": generateID,
        }).then(res=> {
          if (res.data?.code === 0) {
            marketingSmsManagementStore.onStatisticsAction({
              "smsType": this.state.smsType,
              "taskGroupId": generateID,
              "taskType": type
            })
          }
        })
      } else {
        marketingSmsManagementStore.onStatisticsAction({
          "smsType": this.state.smsType,
          "taskGroupId": generateID,
          "taskType": type
        })
      }
    }
    //获取资源池的 下拉列表
    marketingSmsManagementStore.onGetResourcePool({
      configTypeList: [type],
      marketingGroupId: [value],
    })
    //获取 短信余额
    if(value) {
      marketingSmsManagementStore.onSmsBalance({
        smsType: type,
        marketGroupId: value
      })
    }
    
  }
  // 修改 签名
  onChangeSign = (e,option) => {
    const strSum = parseInt((option?.children || '').length)+parseInt(this.state.characterNum)+parseInt(this.state.suffixNum)
    this.setState({
      signNum: (option?.children || '').length,
      strNum: strSum,
      smsNum: strSum > 70 ? Math.ceil(strSum/67) : 1,
      signName: option?.children || ''
    })
  }
  onChangeSuffix = (e,option) => {
    const strSum = parseInt(this.state.signNum)+parseInt(this.state.characterNum)+parseInt(option.children.length)
    this.setState({
      suffixNum: option.children.length,
      strNum: strSum,
      smsNum: strSum > 70 ? Math.ceil(strSum/67) : 1
    })
  }
  onChangeTemplate = (e) => {
    const strSum = parseInt(this.state.signNum)+parseInt(e.target.value.length)+parseInt(this.state.suffixNum)
    this.setState({
      characterNum: e.target.value.length,
      strNum: strSum,
      smsNum: strSum > 70 ? Math.ceil(strSum/67) : 1,
      content: e.target.value,
    })
    this.replaceVar(e.target.value)
  }
  onSelectTemplate = (e) => {
    this.setState({
      textAreaStart:e.target.selectionStart
    })
  }
  onChangeInsertVariable =() => {
    const { content, textAreaStart } = this.state
    const start = content?.substring(0, textAreaStart)
    const end = content?.substring(textAreaStart)
    const arr = this.extractMissingNumbers(content)
    const idx = arr.missing.length>0 ? arr.missing[0] : arr.max + 1
    this.setState({
      content: `${start}{%变量${idx}%}${end}`,
      textAreaStart: this.state.textAreaStart + (`{%变量${idx}%}`).length
    })
    this.formRef.current.setFieldsValue({
      'content': `${start}{%变量${idx}%}${end}`,
    })
  }
  // 点击 模板列表页面的 使用按钮
  onChangeInsertModel =(value)=>{
    const strSum = parseInt(this.state.signNum)+parseInt(value.length)+parseInt(this.state.suffixNum)
    this.formRef.current.setFieldsValue({
      'content': value,
    })
    this.setState({
      characterNum: value.length,
      strNum: strSum,
      smsNum: strSum > 70 ? Math.ceil(strSum/67) : 1,
      content: value
    })
  }
  // 定时时间 checkbox
  onChangeRegularlySend = (value) => {
    this.setState({
      regularlyTime: value.target.checked
    })
  }
  // 点击按钮 编辑变量
  handleEditVar = () => {
    this.setState({
      editVarVisible: true
    })
  }
  // 替换模板内容中的变量
  replaceTemplateVariables=(str, replacements) => {
    const {marketingSmsManagementStore} = this.props
    const { excelList, phoneTable } = marketingSmsManagementStore
    // 将替换数组转为 { "{%key%}": "value" } 格式的对象
    const replacementMap = Object.fromEntries(
      replacements.map(item => [
        item.key, 
        this.state.smsType==='1' ? item?.value : excelList[0][phoneTable.find(a=>a?.title === item?.value)?.name] || ''
      ])
    );
  
    // 生成匹配所有 key 的正则表达式（自动转义特殊字符）
    const regex = new RegExp(
      replacements.map(item => this.escapeRegExp(item.key)).join('|'),
      'g'
    );
  
    // 执行替换操作
    return str.replace(regex, match => replacementMap[match] || '');
  }
  // 辅助函数：转义正则特殊字符
  escapeRegExp = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
  handleCancelEditVar = () => {
    const {marketingSmsManagementStore} = this.props
    const { templateParams, templateObj } = marketingSmsManagementStore
    if(templateObj) {
      const val = this.replaceTemplateVariables(this.state.content, templateParams)
      this.setState({
        editVarVisible: false,
        phoneContent: val
      })
    } else {
      this.replaceVar(this.state.content)
    }
  }
  // 点击按钮 插入短链
  handleShortLink = () => {
    const {marketingShortLinkStore, accountStore} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    marketingShortLinkStore.onSearchJobAction({
      page: 1, 
      size: PAGE_SIZE_DEFAULT, 
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
      marketGroupId: this.state.groupVal
    }).then(res=> {
      if(res?.data?.code ===0) {
        this.setState({
          shortLinkModalVisible: true
        })
      }
    })
  }
  handleCancelShortLink = () => {
    this.setState({
      shortLinkModalVisible: false
    })
  }
  // 点击 插入短链接页面的 【插入】按钮
  onChangeInsertShortLink =(value) => {
    const { content, textAreaStart } = this.state
    const start = content?.substring(0, textAreaStart)
    const end = content?.substring(textAreaStart)
    const strSum = parseInt(this.state.signNum)+parseInt((`${start} ${value} ${end}`).length)+parseInt(this.state.suffixNum)
    this.setState({
      characterNum: (`${start} ${value} ${end}`).length,
      strNum: strSum,
      smsNum: strSum > 70 ? Math.ceil(strSum/67) : 1,
      content: `${start} ${value} ${end}`,
      textAreaStart: this.state.textAreaStart + (` ${value} `).length,
    })
    this.formRef.current.setFieldsValue({
      'content': `${start} ${value} ${end}`,
    })
    this.replaceVar(`${start} ${value} ${end}`)
  }
  // 点击按钮 插入列
  handleInsertColumn = (e, value) => {
    const { content, textAreaStart } = this.state
    const start = content?.substring(0, textAreaStart)
    const end = content?.substring(textAreaStart)
    const strSum = parseInt(this.state.signNum)+parseInt((`${start}{%${value}%}${end}`).length)+parseInt(this.state.suffixNum)
    this.setState({
      characterNum: (`${start}{%${value}%}${end}`).length,
      strNum: strSum,
      smsNum: strSum > 70 ? Math.ceil(strSum/67) : 1,
      content: `${start}{%${value}%}${end}`,
      textAreaStart: this.state.textAreaStart + (`{%${value}%}`).length,
    })
    this.formRef.current.setFieldsValue({
      'content': `${start}{%${value}%}${end}`,
    })
    this.replaceVar(`${start}{%${value}%}${end}`)
  }
  escapeRegExp = (string)=> {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
  //替换变量
  replaceVar=(text)=> {
    const {marketingSmsManagementStore} = this.props
    const { excelList, phoneTable } = marketingSmsManagementStore
    // const variables = text.match(/\{%(.*?)%\}/g)  // 带{%%}
    const variables = text.match(/\{%[^%]+%\}/g)?.map(match => match.replace(/\{%|\%\}/g, ''));  //不带{%%}
    const val = variables?.map(b=> {return {
      key: `{%${b}%}`,
      value: b==='手机号码' ? excelList[0]?.phone : excelList[0][phoneTable.find(a=>a?.title === b)?.name] || ''
    }})

    // 替换所有变量
    const result = val?.reduce((currentText, item) => {
      return currentText.replace(new RegExp(this.escapeRegExp(item.key), 'g'), item.value);
    }, text);
    this.setState({
      phoneContent: variables ? result : text,
    })
  }
  // 点击按钮 预览
  handlePersonalPhone = () => {
    const {marketingSmsManagementStore, accountStore} = this.props
    const { generateID, templateObj, templateParams } = marketingSmsManagementStore
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    const signId = this.formRef.current.getFieldValue('signId')
    const content = this.formRef.current.getFieldValue('content')
    const suffixContent = this.formRef.current.getFieldValue('suffixContent')
    marketingSmsManagementStore.onSelfAction({
      "signId": signId,
      "suffixContent": suffixContent,
      "taskGroupId": generateID,
      "template": content,
      'sourceType': this.state.isFile ? '2' : '3',
      "templateId": templateObj ? templateObj?.id : null,       
      "variable": this.state.smsType==='2' ? templateObj ? templateParams.map(a=>{return {...a, key: a?.key?.replace(/{%|%}/g, "")}}) : [] : null,
      "isPowerUser": accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
      "page": 1, 
      "size": PAGE_SIZE_DEFAULT, 
    }).then(res=> {
      if(res?.data?.code ===0) {
        this.setState({
          personalPhoneVisible: true,
          sourceType: this.state.isFile ? '2' : '3'
        })
      }
    })
  }
  handleCancelPersonalPhone = () => {
    this.setState({
      personalPhoneVisible: false
    })
  }
  // 点击按钮 文件导入
  handleImportFile = (e,type, isTable) => {
    this.setState({
      importModalVisible: true,
      sourceType: type,
      isTable: isTable
    })
  }
  handleCancelImportFile = () => {
    const {marketingSmsManagementStore} = this.props
    const {excelList} = marketingSmsManagementStore
    this.setState({
      importModalVisible: false,
      sourceType: '',
      isFile: this.state.smsType ==='2' && excelList.length>0 ? true : false
    })
  }
  // 点击按钮 资源池导入
  handleImportResourcePool = (e, value, isTable) => {
    this.setState({
      detailsModalVisible: true,
      sourceType: '3',
      record: value,
      isTable: isTable
    })
  }
  handleCancelResourcePool =()=> {
    const {marketingSmsManagementStore} = this.props
    const { content } = this.state
    const {excelList} = marketingSmsManagementStore
    this.setState({
      detailsModalVisible: false,
      sourceType: '',
      record: null,
      isResourcePool: this.state.smsType ==='2' && excelList.length>0 ? true : false
    })
    this.handleCancelEditVar()
  }
  // 点击按钮 模板列表
  handleModelList = () => {
    const {marketingSmsTemplateStore, accountStore, type} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    marketingSmsTemplateStore.onSearchAction({
      templateType: type,
      status: '1',
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
      marketGroupId: this.state.groupVal,
      page: 1, 
      size: PAGE_SIZE_DEFAULT
    }).then(res=> {
      if(res?.data?.code ===0) {
        this.setState({
          modalVisible: true
        })
      }
    })
    marketingSmsTemplateStore.onGetSign({
      templateType: type,
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
    })
  }
  handleCancelModelList = () => {
    const {marketingSmsManagementStore} = this.props
    const { templateObj } = marketingSmsManagementStore
    this.setState({
      modalVisible: false
    })
    if(templateObj) {
      this.setState({
        content: templateObj?.template,
        phoneContent: templateObj?.template
      })
      this.formRef.current.setFieldsValue({
        content: templateObj?.template
      })
    }
  }
  // 点击按钮 取消模板
  cancelTemplate = () => {
    const {marketingSmsManagementStore} = this.props
    marketingSmsManagementStore.onChangeTemplateObj(null)
    const strSum = parseInt(this.state.signNum)+parseInt(this.state.suffixNum)
    this.formRef.current.setFieldsValue({
      'content': undefined,
    })
    this.setState({
      characterNum: 0,
      strNum: strSum,
      smsNum: strSum > 70 ? Math.ceil(strSum/67) : 1,
      content: '',
      phoneContent: ''
    })
    marketingSmsManagementStore.onChangeTemplateParams([])
  }
  // 点击按钮 详情
  importDetails = (e,type, isValid) => {
    this.setState({
      phoneVisible: true,
      sourceType: type,
      isValid: isValid,
    })
  }
  handleCancelPhoneList =()=> {
    this.setState({
      phoneVisible: false,
      sourceType: '',
      isValid: '',
    })
  }
  // phoneTextArea 发送手机号码文本框 修改
  onChangeHandPhone =(text)=> {
    const value = text.target.value
    //较验手机号的正则表达式
    const regPhone = /^((1[3,5,7,8,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[7]))\d{8}$/
    if(value.length===11) {
      const result = regPhone.test(value)
      if(result) {
        this.addPhone([value])
      } else {
        alertMessage.error('号码格式不正确!')
      }
    } else if(value.length > 11 &&(value.includes(',') || value.includes('，'))) {
      const str = value.replace(/，/g, ",")
      const arr = str.split(',')
      const newArr = arr.filter(a=>regPhone.test(a))
      if(newArr.length>0) {
        this.addPhone(newArr)
      }
    // } else {
    //   alertMessage.error('号码格式不正确!')
    }
  }
  // 添加手机号码
  addPhone = (value) => {
    const {marketingSmsManagementStore, accountStore, type} = this.props
    const { generateID } = marketingSmsManagementStore
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    marketingSmsManagementStore.onAddPhoneAction({
      'phoneList': value,
      'sourceType': '1',
      'taskGroupId': generateID,
      'smsType': this.state.smsType,
      'marketGroupId': this.state.groupVal,
      "taskType": type
    }).then(res=> {
      if (res?.data?.code === 0) {
        marketingSmsManagementStore.onPhoneAction({
          'sourceType': '1',
          'phone': '',
          'taskGroupId': generateID,
          'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
          'page': 1,
          'size': PAGE_SIZE_DEFAULT
        })
        marketingSmsManagementStore.onStatisticsAction({
          "smsType": this.state.smsType,
          "taskGroupId": generateID,
          "taskType": type
        })
        this.formRef.current.setFieldsValue({
          'phoneTextArea': undefined,
        })
      }
    })
  }
  // 关闭 新建短信 窗口
  formHandleCancel=(e, status)=> {
    const { marketingSmsManagementStore, handleCancel, location} = this.props
    const { generateID } = marketingSmsManagementStore
    if(!status) {
      marketingSmsManagementStore.onClearPhoneAction({
        "taskGroupId": generateID,
      })
    }
    handleCancel()
    this.setState({
      smsType: '1',
      signNum: 0,   //签名
      characterNum: 0,  //模板内容
      suffixNum: 0,  //后缀
      strNum: 0,  //字符数
      smsNum: 0,  //短信数
      regularlyTime: null,
      modalVisible: false,
      importModalVisible: false,
      shortLinkModalVisible: false,
      detailsModalVisible: false,
      content: '',
      textAreaStart: 0,
      sum: 0,
      signName: '',
      sourceType: '',
      groupVal: '',
      editVarVisible: false,
      phoneContent: '',
      personalPhoneVisible: false,
      record: null,
      isTable: false,
      isFile: false,
      isResourcePool: false,
      selectedTime: null,
      isDatePicker: 0,
      testSendModalVisible: false,
      testTableData: [],
      testTableColumns: [],
    })
    marketingSmsManagementStore.onChangeTemplateParams([])
    marketingSmsManagementStore.onChangeTemplateObj(null)
    marketingSmsManagementStore.onChangeSmsBalanceSum(0)
    if(this.props?.location?.state?.smsType) {
      history.push(`/smsManagement`,{taskType: this.props?.location?.state?.taskType})
    }
  }
  handleClearPhone = () => {
    const {marketingSmsManagementStore, accountStore, type, smsType, sourceType} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    const { generateID } = marketingSmsManagementStore
    marketingSmsManagementStore.onClearPhoneAction({
      "sourceType": sourceType,
      "taskGroupId": generateID,
    }).then(res=> {
      if (res?.data?.code === 0) {
        marketingSmsManagementStore.onChangeExcelList([])
        marketingSmsManagementStore.onChangePhoneTable([])
        marketingSmsManagementStore.onStatisticsAction({
          "smsType": smsType,
          "taskGroupId": generateID,
          "taskType": type
        })
        this.setState({
          isResourcePool: false,
          isFile: false,
          isTable: false
        })
      }
    })
  }
  // 当前时间的10分钟之内不可以选择
  // 禁用今天之前的日期
  disabledDate = (current) => {
    return current && current < moment().startOf('day');
  };
  // 获取当前精确时间（到秒）
  getCurrentTime = () => moment().clone().add(10, 'minutes');

  // 禁用时间规则（精确到秒）
  disabledTime = (current) => {
    if (!current) return {};
    
    const now = this.getCurrentTime();
    
    // 如果不是今天则不禁用
    if (!current.isSame(now, 'day')) {
      return {
        disabledHours: () => [],
        disabledMinutes: () => [],
        disabledSeconds: () => []
      };
    }

    // 当前时间各维度值
    const currentHour = now.hour();
    const currentMinute = now.minute();
    const currentSecond = now.second();

    return {
      // 禁用小时
      disabledHours: () => [...Array(currentHour).keys()],
      
      // 禁用分钟
      disabledMinutes: (selectedHour) => {
        if (selectedHour === currentHour) {
          return [...Array(currentMinute).keys()];
        }
        return [];
      },
      
      // 禁用秒
      disabledSeconds: (selectedHour, selectedMinute) => {
        if (selectedHour === currentHour && selectedMinute === currentMinute) {
          return [...Array(currentSecond).keys()];
        }
        return [];
      }
    };
  };

  // 
  onOpenChange=(val) => {
    if(!val) {
      this.setState({
        isDatePicker: 0
      })
    }
  }
  // 处理日期选择变化
  handleChangeDatePicker = (date) => {
    if (!date) {
      this.setState({
        selectedTime: null
      })
      return;
    }

    const now = moment();
    let newDate = date.clone();

    // 如果是今天
    if (date.isSame(now, 'day')) {
      const nowPlus10 = this.state.isDatePicker+1===1 ? now.clone().add(10, 'minutes') : now.clone();
      
      // 如果超过当天时间，自动跳转次日 00:00
      if (nowPlus10.isAfter(date.endOf('day'))) {
        newDate = date.clone().add(1, 'day').startOf('day');
      } else {
        newDate = nowPlus10
          .set('date', date.date())
          .set('month', date.month())
          .set('year', date.year());
      }
    } else {
      // 非今天日期重置为当天起始时间
      newDate = date.clone().startOf('day');
    }

    this.setState({
      selectedTime: newDate
    })
    this.formRef.current.setFieldsValue({
      'scheduleTime': newDate,
    })
  };
  
  createSign = () => {
    const {accountStore} = this.props
    history.push(`/smsSignature`)
    accountStore.setSeletedItem('smsSignature')
    accountStore.onMenuClick(['smsSignature'])
  }
  createPool = () => {
    const {accountStore} = this.props
    history.push(`/resourcePool`)
    accountStore.setSeletedItem('resourcePool')
    accountStore.onMenuClick(['resourcePool'])
  }

  // 提取内容中的变量
  extractVariables = (content) => {
    if (!content) return []
    const variables = content.match(/\{%([^%]+)%\}/g)
    if (!variables) return []
    return variables.map(variable => variable.replace(/\{%|\%\}/g, ''))
  }

  // 生成测试表格数据
  generateTestTableData = (count = 1) => {
    const data = []
    for (let i = 0; i < count; i++) {
      data.push({
        key: Date.now() + i,
        phone: '',
      })
    }
    return data
  }

  handleAddRow = () => {
    const { testTableData } = this.state
    const newRow = { key: Date.now(), phone: '' }
    this.setState({ testTableData: [...testTableData, newRow] })
  }

  handleDeleteRow = (key) => {
    const { testTableData } = this.state
    if (testTableData.length === 1) return
    this.setState({ testTableData: testTableData.filter(row => row.key !== key) })
  }

  // 获取表格列定义（Form.List fields, add, remove）
  getTestTableColumns = (fields, add, remove) => {
    const variables = this.extractVariables(this.state.content)
    const columns = [
      {
        title: '手机号码',
        dataIndex: '手机号码',
        key: 'phone',
        width: 150,
        render: (text, record, idx) => (
          <Form.Item name={[record.name, '手机号码']} style={{ margin: 0 }}>
            <Input placeholder="请输入手机号" />
          </Form.Item>
        )
      },
      ...variables.map(variable => ({
        title: variable,
        dataIndex: variable,
        key: variable,
        width: 150,
        render: (text, record) => (
          <Form.Item name={[record.name, variable]} style={{ margin: 0 }}>
            <Input placeholder={`请输入${variable}`} />
          </Form.Item>
        )
      })),
      {
        title: '操作',
        key: 'action',
        width: 80,
        render: (text, record, idx) => (
          <span>
            <Button size="small" onClick={() => fields.length < 10 && add()} disabled={fields.length >= 10} style={{ marginRight: 4 }}>+</Button>
            <Button size="small" onClick={() => remove(record.name)} disabled={fields.length === 1}>-</Button>
          </span>
        )
      }
    ]
    return columns
  }

  // 打开测试发送弹窗时初始化一行
  handleShowTestSend = () => {
    this.formRef.current.validateFields().then(fieldsValue => {
      if (!fieldsValue?.content) {
        return alertMessage.error('请输入短信内容!')
      }
      this.setState({
        testSendModalVisible: true
      }, () => {
        // 初始化一行
        this.testFormRef.current && this.testFormRef.current.setFieldsValue({ testData: [{}] })
      })
    }).catch(() => { })
  }

  // 测试发送
  handleTestSend = () => {
    this.formRef.current.validateFields().then(fieldsValue => {
      const { marketingSmsManagementStore, type, onSearch } = this.props
      const { templateObj, generateID, templateParams } = marketingSmsManagementStore

      // 通用参数
      const paramsBase = {
        taskGroupId: generateID,
        taskType: type,
        smsType: this.state.smsType,
        taskName: fieldsValue?.taskName,
        marketingGroupId: fieldsValue?.marketingGroupId,
        expoResume: fieldsValue?.expoResume,
        suffixContent: fieldsValue?.suffixContent,
        signId: fieldsValue?.signId,
        templateParams: this.state.smsType === '1' ? (templateObj ? templateParams.map(a => a?.value) : []) : null,
        variable: this.state.smsType === '2' ? (templateObj ? templateParams.map(a => ({ ...a, key: a?.key?.replace(/{%|%}/g, "") })) : []) : null,
        content: fieldsValue?.content,
        isSchedule: this.state.regularlyTime ? 0 : 1,
        scheduleTime: fieldsValue?.scheduleTime ? moment(fieldsValue?.scheduleTime).format('YYYY-MM-DD HH:mm:ss') : null,
        useTemplate: templateObj ? 0 : 1,
        templateId: templateObj ? templateObj.id : null,
      }

      let phoneList = []
      let personalTestParamList = []

      if (this.state.smsType === '1') {
        // 普通短信校验
        const receiver = this.testFormRef.current.getFieldValue('testPhoneArea')
        if (!receiver) {
          alertMessage.error("请输入测试手机号").then()
          return
        }
        const regPhone = /^((1[3,5,7,8,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[7]))\d{8}$/
        const arr = receiver.replace(/，/g, ',').split(',')
        const okArr = arr.filter(a => regPhone.test(a)) ?? []
        const failedArr = arr.filter(a => !regPhone.test(a)) ?? []
        if (failedArr.length > 0) {
          let error = "错误的手机号：" + failedArr.join(',') + " 请重新输入"
          alertMessage.error(error, 5).then()
          return
        }
        if (okArr.length > 10) {
          alertMessage.error("当前测试手机号只允许10个以内的手机号").then()
          return
        }
        phoneList = okArr
      } else {
        // 个性短信校验
        const testData = this.testFormRef.current.getFieldValue('testData') || []
        const validData = testData.filter(item => item && item['手机号码'] && item['手机号码'].trim())
        if (validData.length === 0) {
          alertMessage.error("请至少输入一条有效的测试数据").then()
          return
        }
        const regPhone = /^((1[3,5,7,8,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[7]))\d{8}$/
        const invalidPhones = validData.filter(item => !regPhone.test(item['手机号码']))
        if (invalidPhones.length > 0) {
          let error = "存在无效的手机号格式：" + invalidPhones.map(item => item['手机号码']).join(',') + "，请重新输入"
          alertMessage.error(error, 5).then()
          return
        }
        if (validData.length > 10) {
          alertMessage.error("当前测试数据只允许10条以内的记录").then()
          return
        }
        personalTestParamList = validData
      }

      const params = {
        ...paramsBase,
        phoneList,
        personalTestParamList
      }
      marketingSmsManagementStore.onSendTestPhone(params).then(() => {
        this.setState({ testSendModalVisible: false })
        onSearch()
      })
    }).catch(() => {})
  }

  //关闭测试发送窗口
  handleCancelTestSend = () => {
    this.setState({ 
      testSendModalVisible: false,
      testTableData: [],
      testTableColumns: []
    })
  }

  render() {
    const { marketingSmsManagementStore, addModalVisible, type, t } = this.props
    const { isFetchingPhone, signList, templateObj, handPhoneNum,validHandPhoneNum,invalidHandPhoneNum, filePhoneNum,validFilePhoneNum,invalidFilePhoneNum,validResourcePhoneNum,invalidResourcePhoneNum, resourcePhoneNum, allNum, groupList, phoneTable, resourcePoolList, excelList, expoList, isTestSendFetching } = marketingSmsManagementStore
    return (
      <>
        <Modal
          title={t(`marketingManagement.addSmsTask`)}
          closable={true}
          visible={addModalVisible}
          onCancel={e=>this.formHandleCancel(e,false)}
          maskClosable={false}
          destroyOnClose={true}
          width={'70%'}
          centered
          footer={[
            <Button key="Test" type="primary" onClick={this.handleShowTestSend} >{t(`general.testSend`)}</Button>,
            <Button key="Save" type="primary" onClick={this.handleOkConfirm} >{t(`general.commitSend`)}</Button>,
            <Button key="Cancel" onClick={e=>this.formHandleCancel(e,false)}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Spin spinning={isFetchingPhone}>
          <Row gutter={[10, 10]}>
            <Col span={14}>
              <Tabs activeKey={this.state.smsType} onChange={this.onChange} destroyInactiveTabPane={true} className='messagesTabs marketingSmsTemplateTabs m0'>
                <TabPane tab={t(`marketingManagement.regularSMS`)} key="1">
                  <Form ref={this.formRef} key="addMapping">
                    <Row gutter={[10, 10]}>
                      <Col span={4}><div className='leftTit'>{t(`marketingManagement.taskTitle`)}</div></Col>
                      <Col span={20}>
                        <Form.Item name="taskName" rules={[{required: true, message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.taskTitle`)}`}]}>
                          <Input showCount maxLength={20} placeholder='本次发送任务标题，非必填' />
                        </Form.Item>
                      </Col>
                      <Col span={4}><div className='leftTit'>{t(`marketingManagement.marketingGroup`)}</div></Col>
                      <Col span={10}>
                        <Form.Item name="marketingGroupId"
                          rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.marketingGroup`)}`}]}
                          >
                          <Select placeholder={t(`general.pleaseSelect`)} showSearch filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          } onChange={this.onChangeGroup}>
                            {groupList?.map(item => (<Select.Option key={item.id} value={item.id}>{item.groupName}</Select.Option>))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={10}>
                        <Form.Item name="expoResume" label={t(`marketingManagement.exhibitionSession`)}
                          rules={[{required: true, message: `仅用于统计`}]}
                        >
                          <Select placeholder='仅用于统计' allowClear showSearch filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          } disabled={!this.state.groupVal}>
                            {expoList?.map(item => (<Select.Option key={item?.expoResume} value={item?.expoResume}>{item?.expoCityName ? `${item?.expoResume}-${item?.expoCityName}` : `${item?.expoResume}`}</Select.Option>))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={4}><div className='leftTit'>{t(`marketingManagement.selectSignature`)}</div></Col>
                      <Col span={10}>
                        <Form.Item name="signId" label={t(`marketingManagement.signature`)}
                          rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.signature`)}`}]}
                        >
                          <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          } onChange={this.onChangeSign} disabled={!this.state.groupVal} dropdownRender={(menu) => (
                            <>
                              {menu}
                              <Divider
                                style={{
                                  margin: '8px 0',
                                }}
                              />
                              <div style={{paddingLeft:20}}>
                                前往<Button type='link' onClick={this.createSign} style={{padding: '4px 5px'}}>{t(`marketingManagement.smsSignature`)}</Button>创建
                              </div>
                            </>
                          )}>
                            {signList?.filter(a=>a?.marketingGroupId ===this.state.groupVal)?.map(item => (<Select.Option key={item.id} value={item.id}>{`【${item.sign}】`}</Select.Option>))}
                          </Select>
                        </Form.Item>
                      </Col>
                      {type==='1' ? <Col span={10}>
                        <Form.Item name="suffixContent" label={t(`marketingManagement.suffix`)}
                          rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.suffix`)}`}]}
                        >
                          <Select placeholder={t(`general.pleaseSelect`)} allowClear disabled onChange={this.onChangeSuffix}>
                            <Select.Option key={t(`marketingManagement.replyWithR`)} value={t(`marketingManagement.replyWithR`)}>{t(`marketingManagement.replyWithR`)}</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col> : null}
                      <Col span={24}><div className='leftTit'>{t(`marketingManagement.editContent`)}</div></Col>
                      <Col span={24}>
                        <Row gutter={8}>
                          <Col span={24} className='smsTextArea'>
                            <Form.Item name='content' onChange={this.onChangeTemplate} onSelect={this.onSelectTemplate} style={{marginBottom: 0}}>
                              <TextArea disabled={!this.state.groupVal || templateObj} ref={ r => this.textAreaRef = r} rows={4} placeholder="请编辑短信内容（短信签名请在上方选择，内容框无需输入签名）" style={{width: '100%'}} />
                            </Form.Item>
                          </Col>
                          <Col span={24} style={{position: 'relative'}}>
                            <div className='interSum'>
                              {t(`marketingManagement.total4`)}<span style={{color: '#ff5200'}}>{this.state.strNum}</span>{t(`marketingManagement.total2`)}<span style={{color: 'red'}}>{this.state.smsNum}</span>{t(`marketingManagement.total3`)}
                              <Tooltip title={t('marketingManagement.templateTips')}>
                                <QuestionCircleFilled />
                              </Tooltip>
                            </div>
                            { templateObj ?
                              <div className='cancelTemplate'>
                                <span style={{color: '#ff5200'}}>已报备的模板不允许编辑内容</span>
                                <Button type='link' onClick={this.cancelTemplate} icon={<CloseOutlined />}>取消模板</Button>
                              </div>
                            : null }
                          </Col>
                          <Col span={24}>
                            <div className='shortLink'>
                              <div className='textLink' style={{textAlign: 'right'}}>
                                { templateObj ? null : <div className='btn02'>
                                  <Button disabled={!this.state.groupVal} type='link' onClick={this.handleShortLink} icon={<IeOutlined />}>{t(`marketingManagement.insetShortLink`)}</Button>
                                </div>}
                                { templateObj ? <Button type="primary" onClick={this.handleEditVar} style={{marginRight: 10}}>{t(`marketingManagement.editVar`)}</Button> : null}
                                <Button disabled={!this.state.groupVal} type="primary" onClick={this.handleModelList} >{t(`marketingManagement.modelList`)}</Button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={24}><div className='leftTit'>{t(`marketingManagement.sendPhone`)}</div></Col>
                      <Col span={24}>
                          <Row gutter={8}>
                            {this.state.groupVal ?
                            <Col span={24}>
                              <div className='interSum sms' style={{ background: 'rgba(7, 58, 120, .03)', padding: 10}}>
                                <Row gutter={50}>
                                  <Col flex="180px" style={{alignItems: 'center', borderRight: '1px solid #dddddd'}}>
                                    <span style={{color: 'rgb(115, 209, 61)', fontSize: 20}}>
                                      {this.state.groupVal && validHandPhoneNum + validFilePhoneNum +  validResourcePhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e, null, '0')} style={{padding: 0, color: 'rgb(115, 209, 61)', fontSize: 20}}>{validHandPhoneNum + validFilePhoneNum +  validResourcePhoneNum}</Button> : validHandPhoneNum + validFilePhoneNum +  validResourcePhoneNum}
                                    </span><br />
                                    <span style={{color: 'rgb(115, 209, 61)', fontWeight: 'bold'}}>{t(`marketingManagement.numberText7`)}</span>
                                    <Tooltip title={t('marketingManagement.personalTemplateTips')}>
                                      <QuestionCircleFilled />
                                    </Tooltip>
                                  </Col>
                                  <Col flex="auto">
                                    <Row gutter={16}>
                                      <Col span={8}>
                                        <span style={{color: 'rgb(115, 209, 61)', fontSize: 20}}>{this.state.groupVal && validHandPhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'1', '0')} style={{padding: 0, color: 'rgb(115, 209, 61)', fontSize: 20}}>{validHandPhoneNum}</Button> : validHandPhoneNum}</span>
                                        <span style={{color: '#999999'}}> / </span>
                                        <span style={{color: 'rgb(255, 77, 79)'}}>{this.state.groupVal && invalidHandPhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'1', '1')} style={{padding: 0, color: 'rgb(255, 77, 79)'}}>{invalidHandPhoneNum}</Button> : invalidHandPhoneNum}</span><br />
                                        <span style={{color: '#666666'}}>{t(`marketingManagement.numberText1`)}</span>
                                      </Col>
                                      <Col span={8}>
                                        <span style={{color: 'rgb(115, 209, 61)', fontSize: 20}}>{this.state.groupVal && validFilePhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'2', '0')} style={{padding: 0, color: 'rgb(115, 209, 61)', fontSize: 20}}>{validFilePhoneNum}</Button> : validFilePhoneNum}</span>
                                        <span style={{color: '#999999'}}> / </span>
                                        <span style={{color: 'rgb(255, 77, 79)'}}>{this.state.groupVal && invalidFilePhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'2', '1')} style={{padding: 0, color: 'rgb(255, 77, 79)'}}>{invalidFilePhoneNum}</Button> : invalidFilePhoneNum}</span><br />
                                        <span style={{color: '#666666'}}>{t(`marketingManagement.numberText2`)}</span>
                                      </Col>
                                      <Col span={8}>
                                        <span style={{color: 'rgb(115, 209, 61)', fontSize: 20}}>{this.state.groupVal && validResourcePhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'3', '0')} style={{padding: 0, color: 'rgb(115, 209, 61)', fontSize: 20}}>{validResourcePhoneNum}</Button> : validResourcePhoneNum}</span>
                                        <span style={{color: '#999999'}}> / </span>
                                        <span style={{color: 'rgb(255, 77, 79)'}}>{this.state.groupVal && invalidResourcePhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'3', '1')} style={{padding: 0, color: 'rgb(255, 77, 79)'}}>{invalidResourcePhoneNum}</Button> : invalidResourcePhoneNum}</span><br />
                                        <span style={{color: '#666666'}}>{t(`marketingManagement.numberText3`)}</span>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                                {/* {t(`marketingManagement.numberText1`)}<span style={{color: 'rgb(64, 169, 255)'}}>{this.state.groupVal && handPhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'1')} style={{padding: '4px'}}>{handPhoneNum}</Button> : handPhoneNum}</span>
                                {t(`marketingManagement.numberText4`)}<span style={{color: 'rgb(115, 209, 61)'}}>{validHandPhoneNum}</span>
                                {t(`marketingManagement.numberText5`)}<span style={{color: 'rgb(255, 77, 79)'}}>{invalidHandPhoneNum}</span>
                                {t(`marketingManagement.numberText2`)}<span style={{color: 'rgb(64, 169, 255)'}}>{this.state.groupVal && filePhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'2')} style={{padding: '4px'}}>{filePhoneNum}</Button> : filePhoneNum}</span>
                                {t(`marketingManagement.numberText4`)}<span style={{color: 'rgb(115, 209, 61)'}}>{validFilePhoneNum}</span>
                                {t(`marketingManagement.numberText5`)}<span style={{color: 'rgb(255, 77, 79)'}}>{invalidFilePhoneNum}</span>
                                {t(`marketingManagement.numberText3`)}<span style={{color: 'rgb(64, 169, 255)'}}>{this.state.groupVal && resourcePhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'3')} style={{padding: '4px'}}>{resourcePhoneNum}</Button> : resourcePhoneNum}</span>
                                {t(`marketingManagement.numberText4`)}<span style={{color: 'rgb(115, 209, 61)'}}>{validResourcePhoneNum}</span>
                                {t(`marketingManagement.numberText5`)}<span style={{color: 'rgb(255, 77, 79)'}}>{invalidResourcePhoneNum}</span>。<br /> */}
{/* 




                                {t(`marketingManagement.total6`)}<span style={{color: '#ff5200'}}>{handPhoneNum}</span>{t(`marketingManagement.total7`)}
                                { this.state.groupVal && handPhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'1')} style={{padding: '4px'}}>详情</Button> : null}
                                {t(`marketingManagement.total8`)}
                                <span style={{color: '#ff5200'}}>{filePhoneNum}</span>{t(`marketingManagement.total7`)}
                                { this.state.groupVal && filePhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'2')} style={{padding: '4px'}}>详情</Button> : null}
                                {t(`marketingManagement.total9`)}
                                <span style={{color: '#ff5200'}}>{resourcePhoneNum}</span>{t(`marketingManagement.total7`)}
                                { this.state.groupVal && resourcePhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'3')} style={{padding: '4px'}}>详情</Button> : null}
                                {t(`marketingManagement.total10`)}
                                <span style={{color: '#ff5200'}}>{allNum}</span>{t(`marketingManagement.total7`)} */}
                                
                              </div>
                            </Col> : null
                            }
                            <Col span={24} className='phoneTextArea'>
                              <Form.Item name='phoneTextArea' style={{marginBottom: 0}}>
                                <TextArea onPressEnter={this.onChangeHandPhone} disabled={!this.state.groupVal} rows={3} placeholder="请输入11位手机号" style={{width: '100%'}} />
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <div className='f_red' style={{ float: 'left', paddingLeft: '10px', paddingTop: '10px' }}><ExclamationCircleFilled /> 请输入正确的手机号，多个手机号使用逗号分隔，按回车键确认正确的手机号</div>
                              <div className='shortLink' style={{textAlign: 'right'}}>
                                <Button disabled={!this.state.groupVal} type="primary" onClick={e=>this.handleImportFile(e, '2')} style={{marginRight: 10}}>{t(`marketingManagement.importFile`)}</Button>
                                <Dropdown overlay={resourcePoolList.length > 0 ? (<Menu>
                                  {resourcePoolList?.map((b,i)=><Menu.Item key={i}><a onClick={e=>this.handleImportResourcePool(e, b)}>{b?.resourcePoolName}</a></Menu.Item>)}
                                </Menu>) : (<div style={{padding: '0 20px', backgroundColor: '#cfdbe6'}}>
                                  前往<Button type='link' onClick={this.createPool} style={{padding: '4px 5px'}}>{t(`menu.resourcePool`)}</Button>创建
                                </div>)} placement="bottomLeft" disabled={!this.state.groupVal} >
                                  <Button disabled={!this.state.groupVal} type="primary" onClick={e => e.preventDefault()} >{t(`marketingManagement.importResourcePool`)}</Button>
                                </Dropdown>
                              </div>
                            </Col>
                          </Row>
                      </Col>
                      <Col span={4}><div className='leftTit'>{t(`marketingManagement.regularlySend`)}</div></Col>
                      <Col span={6}>
                        <Form.Item name="isSchedule">
                          <Checkbox onChange={this.onChangeRegularlySend} checked={this.state.regularlyTime}>
                            {`${t('marketingManagement.regularlyTime')} `} 
                            <Tooltip title={t('marketingManagement.regularlySendTips')}>
                              <QuestionCircleFilled />
                            </Tooltip>
                          </Checkbox>
                        </Form.Item>
                      </Col>
                      {this.state.regularlyTime ? <Col span={8}><Form.Item name="scheduleTime"
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.regularlySend`)}`,
                           }]}>
                        <DatePicker
                          showTime={{
                            // defaultValue: moment('00:00:00', 'HH:mm:ss'),
                            // disabledTime: this.disabledTime,
                            format: 'HH:mm:ss'
                          }}
                          disabledTime={this.disabledTime}
                          disabledDate={this.disabledDate}
                          format="YYYY-MM-DD HH:mm:ss"
                          value={this.state.selectedTime}
                          onOpenChange={this.onOpenChange}
                          // onSelect={this.handleChangeDatePicker}
                          placeholder={t(`general.pleaseEnter`)}
                          style={{width: '100%'}}
                          showNow={false}
                        />
                      </Form.Item></Col> : null}
                      <Col span={4} style={{paddingTop: 5}}>
                      </Col>
                    </Row>
                  </Form>
                </TabPane>
                <TabPane tab={t(`marketingManagement.personalizedSMS`)} key="2">
                  <Form ref={this.formRef} key="addMapping">
                    <Row gutter={[10, 10]}>
                      <Col span={4}><div className='leftTit'>{t(`marketingManagement.taskTitle`)}</div></Col>
                      <Col span={20}>
                        <Form.Item name="taskName" rules={[{required: true, message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.taskTitle`)}`}]}>
                          <Input showCount maxLength={20} placeholder='本次发送任务标题，非必填' />
                        </Form.Item>
                      </Col>
                      <Col span={4}><div className='leftTit'>{t(`marketingManagement.marketingGroup`)}</div></Col>
                      <Col span={10}>
                        <Form.Item name="marketingGroupId" rules={[{
                          required: true,
                          message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.taskTitle`)} ${t(`general.withoutSpecialChats`)}`,
                          pattern: new RegExp(/^[^&|;\\]*$/)
                        }]}>
                          <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          } onChange={this.onChangeGroup}>
                            {groupList?.map(item => (<Select.Option key={item.id} value={item.id}>{item.groupName}</Select.Option>))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={10}>
                        <Form.Item name="expoResume" label={t(`marketingManagement.exhibitionSession`)}
                          rules={[{required: true, message: `仅用于统计`}]}
                        >
                          <Select placeholder='仅用于统计' allowClear showSearch filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          } disabled={!this.state.groupVal}>
                            {expoList?.map(item => (<Select.Option key={item?.expoResume} value={item?.expoResume}>{item?.expoCityName ? `${item?.expoResume}-${item?.expoCityName}` : `${item?.expoResume}`}</Select.Option>))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={12}><div className='leftTit'>{t(`marketingManagement.sendPhone`)}</div></Col>
                      <Col span={12} style={{textAlign: 'right'}}><Button disabled={!this.state.groupVal || excelList.length===0} loading={isFetchingPhone} onClick={this.handleClearPhone} type="primary">{t(`general.clearPhone`)}</Button></Col>
                      <Col span={24}>
                        <PersonalSearchResult sourceType={this.state.sourceType} />
                      </Col>
                      <Col span={24}>
                          <Row gutter={8}>
                            <Col span={12}>
                                {t(`marketingManagement.total11`)}<span style={{color: '#ff5200', fontWeight: 'bold'}}>{allNum}</span>
                                {t(`marketingManagement.total12`)}<span style={{color: '#ff5200', fontWeight: 'bold'}}>
                                  { this.state.isFile ? (filePhoneNum - allNum)>=0 ? filePhoneNum - allNum : 0:(resourcePhoneNum - allNum)>=0 ? resourcePhoneNum - allNum : 0}
                                </span>
                                {t(`marketingManagement.total7`)}
                                <Tooltip title={t('marketingManagement.personalTemplateTips')}>
                                  <QuestionCircleFilled />
                                </Tooltip>
                            </Col>
                            <Col span={12} style={{textAlign: 'right'}}>
                                <Button disabled={!this.state.groupVal || this.state.isResourcePool} type="primary" onClick={e=>this.handleImportFile(e, '2', true)} style={{marginRight: 10}}>{t(`marketingManagement.importTable`)}</Button>
                                <Dropdown overlay={resourcePoolList.length > 0 ? (<Menu>
                                  {resourcePoolList?.map((b,i)=><Menu.Item key={i}><a onClick={e=>this.handleImportResourcePool(e, b, true)}>{b?.resourcePoolName}</a></Menu.Item>)}
                                </Menu>) : (<div style={{padding: '0 20px', backgroundColor: '#cfdbe6'}}>
                                  前往<Button type='link' onClick={this.createPool} style={{padding: '4px 5px'}}>{t(`menu.resourcePool`)}</Button>创建
                                </div>)} placement="bottomLeft" disabled={!this.state.groupVal || this.state.isFile} >
                                  <Button type="primary" onClick={e => e.preventDefault()} >{t(`marketingManagement.importResourcePool`)}</Button>
                                </Dropdown>
                            </Col>
                          </Row>
                      </Col>
                      <Col span={4}><div className='leftTit'>{t(`marketingManagement.selectSignature`)}</div></Col>
                      <Col span={10}>
                        <Form.Item name="signId" label={t(`marketingManagement.signature`)}
                          rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.signature`)}`}]}
                        >
                          <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          } onChange={this.onChangeSign} disabled={!this.state.groupVal} dropdownRender={(menu) => (
                            <>
                              {menu}
                              <Divider
                                style={{
                                  margin: '8px 0',
                                }}
                              />
                              <div style={{paddingLeft:20}}>
                                前往<Button type='link' onClick={this.createSign} style={{padding: '4px 5px'}}>{t(`marketingManagement.smsSignature`)}</Button>创建
                              </div>
                            </>
                          )}>
                            {signList?.filter(a=>a?.marketingGroupId ===this.state.groupVal)?.map(item => (<Select.Option key={item.id} value={item.id}>{`【${item.sign}】`}</Select.Option>))}
                          </Select>
                        </Form.Item>
                      </Col>
                      {type==='1' ? <Col span={10}>
                        <Form.Item name="suffixContent" label={t(`marketingManagement.suffix`)}
                          rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.suffix`)}`}]}
                        >
                          <Select placeholder={t(`general.pleaseSelect`)} allowClear disabled onChange={this.onChangeSuffix}>
                            <Select.Option key={t(`marketingManagement.replyWithR`)} value={t(`marketingManagement.replyWithR`)}>{t(`marketingManagement.replyWithR`)}</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col> : null}
                      <Col span={24}><div className='leftTit'>{t(`marketingManagement.editContent`)}</div></Col>
                      <Col span={24}>
                        <Row gutter={8}>
                          <Col span={24} className='smsTextArea'>
                            <Form.Item name='content' onChange={this.onChangeTemplate} onSelect={this.onSelectTemplate} style={{marginBottom: 0}}>
                              <TextArea disabled={!this.state.groupVal || templateObj} ref={ r => this.textAreaRef = r} rows={4} placeholder="请编辑短信内容（短信签名请在上方选择，内容框无需输入签名）" style={{width: '100%'}} />
                            </Form.Item>
                          </Col>
                          <Col span={24} style={{position: 'relative'}}>
                            { templateObj ?
                              <div className='cancelTemplate' style={{position: 'relative', textAlign: 'right', right: 0, borderLeft: '1px solid #d9d9d9', borderRight: '1px solid #d9d9d9'}}>
                                <span style={{color: '#ff5200'}}>已报备的模板不允许编辑内容</span>
                                <Button type='link' onClick={this.cancelTemplate} icon={<CloseOutlined />}>取消模板</Button>
                              </div>
                            : null }
                          </Col>
                          <Col span={24}>
                            <div className='shortLink'>
                              <div className='textLink' style={{textAlign: 'right'}}>
                                <div className='btn02'>
                                  {templateObj ? null : <>
                                    <Dropdown overlay={(<Menu>
                                      {phoneTable?.map((b, i)=><Menu.Item key={i}><a onClick={e=>this.handleInsertColumn(e, b?.title)}>{b?.title}</a></Menu.Item>)}
                                    </Menu>)} placement="bottomLeft" disabled={!this.state.groupVal || !this.state.isTable} >
                                      <Button type='link' icon={<IeOutlined />} onClick={e => e.preventDefault()}>{t(`marketingManagement.insertColumn`)}</Button>
                                    </Dropdown>
                                    <Divider type="vertical" />
                                  </>}            
                                  <Button disabled={!this.state.groupVal || !this.state.content} type='link' onClick={this.handlePersonalPhone} icon={<EyeOutlined />} style={{marginLeft: templateObj ? 10 : 0}}>{t(`marketingManagement.view`)}</Button>
                                </div>
                                { templateObj ? <Button type="primary" onClick={this.handleEditVar} style={{marginRight: 10}}>{t(`marketingManagement.editVar`)}</Button> : null}
                                <Button disabled={!this.state.groupVal} type="primary" onClick={this.handleModelList} >{t(`marketingManagement.modelList`)}</Button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={4}><div className='leftTit'>{t(`marketingManagement.regularlySend`)}</div></Col>
                      <Col span={6}>
                        <Form.Item name="isSchedule">
                          <Checkbox onChange={this.onChangeRegularlySend} checked={this.state.regularlyTime}>
                            {`${t('marketingManagement.regularlyTime')} `} 
                            <Tooltip title={t('marketingManagement.regularlySendTips')}>
                              <QuestionCircleFilled />
                            </Tooltip>
                          </Checkbox>
                        </Form.Item>
                      </Col>
                      {this.state.regularlyTime ? <Col span={8}><Form.Item name="scheduleTime"
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.regularlySend`)}`,
                           }]}>
                        <DatePicker
                          showTime={{
                            //defaultValue: moment('00:00:00', 'HH:mm:ss'),
                            //disabledTime: this.disabledTime,
                            format: 'HH:mm:ss'
                          }}
                          disabledTime={this.disabledTime}
                          disabledDate={this.disabledDate}
                          format="YYYY-MM-DD HH:mm:ss"
                          value={this.state.selectedTime}
                          onOpenChange={this.onOpenChange}
                          onSelect={this.handleChangeDatePicker}
                          placeholder={t(`general.pleaseEnter`)}
                          style={{width: '100%'}}
                        />
                      </Form.Item></Col> : null}
                      <Col span={4} style={{paddingTop: 5}}>
                      </Col>
                    </Row>
                  </Form>
                </TabPane>
              </Tabs>
            </Col>
            <Col span={10}>
                <div className='emulator-balance'>余额：<span>{marketingSmsManagementStore.smsBalanceSum}</span></div>
              <div className='phone_box'>
                <div className='emulator-time'>{moment().format('HH:mm')}</div>
                <div className='emulator-title'>{t('marketingManagement.smsPreview')}</div>
                <div className='emulator-screen scroll'>
                  <div className='emulator-bubble'>
                    {this.state.signName ? this.state.signName : null}
                    {this.state.phoneContent}
                    {type==='1' ? t(`marketingManagement.replyWithR`) : null}
                  </div>
                </div>
                <div className='emulator-foot'>
                  {t('marketingManagement.footTips')}
                  <div className='interSum'>
                    {t(`marketingManagement.total4`)}
                    <span style={{color: '#ff5200'}}>
                      { this.state.signNum + this.state.phoneContent?.length + this.state.suffixNum }
                    </span>
                    {t(`marketingManagement.total2`)}
                    <span style={{color: 'red'}}>{(this.state.signNum + this.state.phoneContent?.length + this.state.suffixNum) > 70 ? Math.ceil((this.state.signNum + this.state.phoneContent?.length + this.state.suffixNum)/67) : 1}</span>
                    {t(`marketingManagement.total3`)}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          </Spin>
        </Modal>
        {this.state.modalVisible ? 
          <TemplateList handleCancel={this.handleCancelModelList} addModalVisible={this.state.modalVisible} onChangeInsertModel={this.onChangeInsertModel} type={type} marketGroupId={this.state.groupVal} /> 
        : null}
        {this.state.shortLinkModalVisible ? 
          <ShortLinkList handleCancel={this.handleCancelShortLink} addModalVisible={this.state.shortLinkModalVisible} onChangeInsertShortLink={this.onChangeInsertShortLink} /> 
        : null}
        {this.state.importModalVisible ? 
          <FormImport handleCancel={this.handleCancelImportFile} importModalVisible={this.state.importModalVisible} type={type} marketGroupId={this.state.groupVal} smsType={this.state.smsType} sourceType={this.state.sourceType} isTable={this.state.isTable} />
        : null}
        {this.state.phoneVisible ? 
          <PhoneList handleCancel={this.handleCancelPhoneList} addModalVisible={this.state.phoneVisible} type={type} smsType={this.state.smsType} sourceType={this.state.sourceType} isValid={this.state.isValid} /> 
        : null}
        {this.state.editVarVisible ? 
          <EditVarModal handleCancel={this.handleCancelEditVar} addModalVisible={this.state.editVarVisible} template={this.state.content} smsType={this.state.smsType} /> 
        : null}
        {this.state.personalPhoneVisible ? 
          <PersonalPhoneList handleCancel={this.handleCancelPersonalPhone} addModalVisible={this.state.personalPhoneVisible} sourceType={this.state.sourceType}/> 
        : null}
        {this.state.detailsModalVisible ? 
          <ResourcePoolList handleCancel={this.handleCancelResourcePool} addModalVisible={this.state.detailsModalVisible} marketGroupId={this.state.groupVal} record={this.state.record} isSelect={true} type={type} smsType={this.state.smsType} />
        : null}


        <Drawer
          title="测试发送"
          autoFocus={true}
          destroyOnClose={true}
          placement="top"
          closable={true}
          onClose={this.handleCancelTestSend}
          visible={this.state.testSendModalVisible}
          size='large'
          style={{ padding: '0px', overflow: 'auto' }}
          bodyStyle={{ overflowY: 'auto' }}
          maskClosable={false}
          extra={
            <Space>
              <Button type="primary" shape="round" loading={isTestSendFetching} onClick={this.handleTestSend}>{t('general.testSend')}</Button>
              <Button shape="round" onClick={this.handleCancelTestSend}>{t('general.close')}</Button>
            </Space>
          }
        >
          <Spin spinning={isTestSendFetching}>
            {
              this.state.smsType === '1' ?
                <Form ref={this.testFormRef} key="testForm">
                  <Form.Item name="testPhoneArea" label="测试手机号" preserve={true} style={{marginBottom: 0}}>
                    <TextArea rows={5} allowClear={true} placeholder="请输入正确的手机号，多个手机号使用逗号分隔，测试手机号最多输入10个手机号"
                              style={{width: '95%'}}/>
                  </Form.Item>
                  <Form.Item name="testEmailAreaNotice" style={{marginBottom: 0}}>
                    <div className="f_red" style={{marginLeft: '85px'}}><ExclamationCircleFilled/> 请输入正确的手机号，多个手机号使用逗号分隔，测试手机号最多输入10个手机号
                    </div>
                  </Form.Item>
                </Form>:
                <Form ref={this.testFormRef} key="testTableForm">
                  <Form.List name="testData">
                    {(fields, { add, remove }) => (
                      <Table
                        dataSource={fields}
                        columns={this.getTestTableColumns(fields, add, remove)}
                        pagination={false}
                        size="small"
                        bordered
                        style={{marginBottom: 16}}
                        scroll={{ x: 'max-content' }}
                        rowKey="key"
                      />
                    )}
                  </Form.List>
                  <div className="f_red" style={{marginBottom: 8}}>
                    <ExclamationCircleFilled/> 请输入正确的手机号，测试手机号最多添加10个手机号
                  </div>
                </Form>
            }
          </Spin>
        </Drawer>
      </>
    )
  }
}

export default withTranslation()(FormModal)
